
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage vehical_dropdown' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('div', { 'className': 'garage-icon' }, [_createElement('svg', {
            'width': '28',
            'height': '20',
            'viewBox': '0 0 28 20',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '2200'
        }, _createElement('path', {
            'className': 'fill_color',
            'd': 'M5.75 11.7502C4.44014 12.6235 3.75 14.7502 3.75 14.7502H2.75V6.75047H11.25L12.25 8.25047H18.75V6.75044C18.75 6.75044 25.75 6.25037 26.25 6.75047C26.75 7.25057 26.25 13.2505 26.25 13.2505C26.0556 12.9891 25.5578 12.5582 25.25 12.2504C23.75 10.7502 20.6013 10.5134 18.75 12.2502C17.6655 13.2676 17.25 14.7502 17.25 14.7502H12.75C12.75 14.7502 12.0599 12.6236 10.75 11.7504C9.12532 10.6673 7.37468 10.6671 5.75 11.7502Z',
            'fill': '#A997C8'
        }), _createElement('path', {
            'd': 'M16.25 0.750244L18.7491 6.55C18.7491 6.55 23.0637 6.55 23.8467 6.55C24.6298 6.55 26.25 6.75024 26.25 7.25024C26.25 7.25024 26.25 8.3134 26.25 8.94988V13.2502H27.25M10.3495 6.55V0.750244M0.75 4.15012V8.94988M3.25 6.55L10.3495 1.75024M5.85012 16.1495C5.85012 16.786 6.10296 17.3964 6.55303 17.8465C7.00309 18.2966 7.61351 18.5494 8.25 18.5494C8.88649 18.5494 9.49691 18.2966 9.94697 17.8465C10.397 17.3964 10.6499 16.786 10.6499 16.1495C10.6499 15.513 10.397 14.9026 9.94697 14.4526C9.49691 14.0025 8.88649 13.7496 8.25 13.7496C7.61351 13.7496 7.00309 14.0025 6.55303 14.4526C6.10296 14.9026 5.85012 15.513 5.85012 16.1495ZM19.6531 16.1495C19.6531 16.786 19.906 17.3964 20.3561 17.8465C20.8061 18.2966 21.4165 18.5494 22.053 18.5494C22.6895 18.5494 23.2999 18.2966 23.75 17.8465C24.2001 17.3964 24.4529 16.786 24.4529 16.1495C24.4529 15.513 24.2001 14.9026 23.75 14.4526C23.2999 14.0025 22.6895 13.7496 22.053 13.7496C21.4165 13.7496 20.8061 14.0025 20.3561 14.4526C19.906 14.9026 19.6531 15.513 19.6531 16.1495Z',
            'stroke': 'black',
            'strokeWidth': '1.5',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round'
        }), _createElement('path', {
            'd': 'M23.25 6.55005H18.75V8.25024H12.75L11.25 6.55005H2.75V14.7502H2.25',
            'stroke': 'black',
            'strokeWidth': '1.5',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round'
        }), _createElement('path', {
            'd': 'M2.75 14.7502H3.75C3.75 14.7502 4.44014 12.6235 5.75 11.7502C7.37468 10.6671 9.12532 10.6673 10.75 11.7504C12.0599 12.6236 12.75 14.7502 12.75 14.7502H17.25C17.25 14.7502 17.6655 13.2677 18.75 12.2502C20.6013 10.5135 23.75 10.7502 25.25 12.2504C25.5578 12.5582 26.0556 12.9891 26.25 13.2505',
            'stroke': 'black',
            'strokeWidth': '1.5',
            'strokeLinecap': 'round'
        }))]), this.size ? _createElement('span', {
        'className': 'garage-size',
        'key': '2447'
    }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '14',
            'height': '14',
            'viewBox': '0 0 14 14',
            'fill': 'none',
            'key': '24910'
        }, _createElement('circle', {
            'cx': '7',
            'cy': '7',
            'r': '6.5',
            'fill': '#FF7936',
            'stroke': 'white'
        }), _createElement('path', {
            'd': 'M4 7L6 9L10 5',
            'stroke': '#231F20',
            'strokeWidth': '1.25',
            'strokeMiterlimit': '10',
            'strokeLinecap': 'round',
            'strokeLinejoin': 'round'
        }))]) : null), _createElement('span', { 'className': 'garage-label' }, _createElement('span', { 'className': 'garage-title' }, this.vehicleString.length ? this.vehicleString : 'Select Vehicle'), [_createElement('svg', {
            'className': 'cm_icon cm_icon-angle ' + (this.isDropdownVisible ? 'up' : 'down'),
            'height': '20px',
            'role': 'img',
            'viewBox': '39 30 565 565',
            'aria-hidden': 'true',
            'key': '29730'
        }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))])), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item form-check' }, _createElement('input', {
                            'type': 'radio',
                            'className': 'form-check-input',
                            'onClick': this.selectVehicle,
                            'readOnly': true,
                            'checked': this.isSelected
                        }), _createElement('label', {
                            'className': 'select-model form-check-label',
                            'onClick': this.selectVehicle
                        }, _createElement('div', { 'className': 'select-model_title' }, '\n            ', window.Convermax.getVehicleLabelWithoutDifferential(this.vehicle), '\n          '), this.vehicle.Differential ? _createElement('div', {
                            'className': 'select-model_differnetial',
                            'key': '405'
                        }, '\n            ', this.vehicle.Differential, '\n          ') : null), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'aria-hidden': 'true',
                                'focusable': 'false',
                                'style': {
                                    width: '16px',
                                    height: '18px'
                                },
                                'className': 'ms-auto',
                                'key': '6190'
                            }, _createElement('use', { 'href': '#icon-delete' }))]));
                    }, { count: undefined })];
            }
            function onClick2() {
                window.Convermax.openGarageDialog('cm_vehicle-search');
            }
            function onClick3() {
                window.Convermax.openGarageDialog('cm_vehicle-search');
            }
            return _createElement('div', { 'className': 'toggle-content cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '46'
            }, _createElement('div', { 'className': 'vehical_title' }, _createElement('span', {}, 'Search parts for:')), _createElement('div', { 'className': 'garage-content' }, _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), _createElement('div', {
                'className': 'add-vehicle btn-sm btn btn-primary',
                'onClick': onClick2.bind(this)
            }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]))) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '2055'
            }, _createElement('div', { 'className': 'vehical_title' }, _createElement('span', {}, 'search parts for:')), _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'add-vehicle btn-sm btn btn-primary',
                'onClick': onClick3.bind(this)
            }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]), _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:garageDropdown"]